import { useEffect, useState } from 'react';

import { KnowledgeLoading, LoadingProps } from './loading';

const translationLoadingMessages = [
  'Translating your article...',
  'Processing language nuances...',
  'Analyzing context and meaning...',
  'Converting linguistic patterns...',
  'Adapting cultural references...',
  'Preserving tone and style...',
  'Fine-tuning grammar structures...',
  'Optimizing word choices...',
  'Reviewing translation accuracy...',
  'Crafting natural phrasing...',
  'Mapping expressions across languages...',
  'Ensuring semantic consistency...',
  'Translating idioms and phrases...',
  'Processing stylistic choices...',
  'Maintaining original intent...',
  'Cross-checking terminology...',
  'Refining sentence flow...',
  'Processing complex sentences...',
  'Balancing accuracy and fluency...',
  'Working through the content...',
  'Interpreting technical terms...',
  'Converting paragraph structure...',
  'Analyzing sentence relationships...',
  'Processing specialized vocabulary...',
  'Adapting formatting conventions...',
  'Handling punctuation differences...',
  'Translating compound expressions...',
  'Processing multi-word phrases...',
  'Evaluating context clues...',
  'Converting time references...',
  'Adapting measurement units...',
  'Processing quoted material...',
  'Handling proper nouns...',
  'Converting date formats...',
  'Analyzing sentence structure...',
  'Processing literary devices...',
  'Translating figurative language...',
  'Adapting rhetorical patterns...',
  'Converting colloquialisms...',
  'Processing domain-specific terms...',
  'Handling ambiguous references...',
  'Translating nested clauses...',
  'Converting passive constructions...',
  'Processing verb tenses...',
  'Adapting word order...',
  'Handling article usage...',
  'Converting pronouns...',
  'Processing prepositions...',
  'Translating conjunctions...',
  'Adapting transitional phrases...',
  'Converting modifiers...',
  'Processing dependent clauses...',
  'Handling relative clauses...',
  'Translating subordinate structures...',
  'Converting compound sentences...',
  'Processing parallel structures...',
  'Adapting emphasis patterns...',
  'Handling negation forms...',
  'Translating conditional statements...',
  'Processing comparative structures...',
];

export function TranslationLoading(
  props: Omit<LoadingProps, 'text'>,
): JSX.Element {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((i) => (i + 1) % translationLoadingMessages.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <KnowledgeLoading text={translationLoadingMessages[index]} {...props} />
  );
}
